import { TypeChecker } from '@attain-apps/type-guards'

import { Expression } from './expression'

export interface Commented<T = any> {
  comment: readonly [...string[], Expression<T>]
}
export namespace Commented {
  export const isCommented: TypeChecker<Commented> = TypeChecker.Factory.object(
    {
      comment: TypeChecker.Factory.custom(
        (val: unknown): val is Commented['comment'] =>
          TypeChecker.isReadonlyArray(val) &&
          val.slice(0, val.length - 1).every(TypeChecker.isString) &&
          Expression.isExpression(val[val.length - 1]),
        {
          typeDescription: 'dms.expression.Commented.comment',
        },
      ),
    },
  ).usingAlias('dms.expression.Commented')

  /**
   * Gets the actual comment from {@link Commented}
   */
  export function getComment(commented: Commented): string {
    return commented.comment.slice(0, commented.comment.length - 1).join('\n')
  }

  /**
   * Gets the underlying {@link Expression} within the given {@link Commented}
   */
  export function getExpressionWithoutComment<T>(
    commented: Commented<T>,
  ): Expression<T> {
    return commented.comment[commented.comment.length - 1]
  }
}
